import { imageModel } from "./defaults";

export const zImageTurbo = imageModel("z-image-turbo", "Z-Image Turbo", {
  text: "z-image/turbo",
});
